import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'helmet/helmet';
import { FormattedMessage } from 'react-intl';

import Styled from 'styled';
import ScrollToTop from 'lib/scroll/scroll-to-top';

import LeftMenu from 'four-nets/photoblog/left-menu/left-menu';
import { Site } from 'four-nets/site';

import defaultStyles from './inspirations.scss';
import InspirationsLoader from './inspirations-loader';

export interface Props {
    styles: typeof defaultStyles;
}

class Inspirations extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    renderHelmet = (H: React.ComponentClass) => {
        const { site } = this.context;

        return site.isWedding ? (
            <FormattedMessage id='WEDDING_INSPIRATIONS'>
                {message => (
                    <H>
                        <title>
                            {message} | {site.name}
                        </title>
                    </H>
                )}
            </FormattedMessage>
        ) : (
            <FormattedMessage id='INSPIRATIONS'>
                {message => (
                    <H>
                        <title>
                            {message} | {site.name}
                        </title>
                    </H>
                )}
            </FormattedMessage>
        );
    };

    render() {
        const { styles } = this.props;
        return (
            <div className={styles.columns}>
                <Helmet render={this.renderHelmet} />
                <ScrollToTop />
                <div className={styles.left}>
                    <h1 className={styles.title}>
                        <FormattedMessage id='INSPIRATIONS' />
                    </h1>
                    <LeftMenu />
                </div>
                <div className={styles.right}>
                    <InspirationsLoader />
                </div>
            </div>
        );
    }
}
export default Styled(defaultStyles)(Inspirations);
